import axios from '@/services/api'

/**
 *
 * @returns {Promise<Object>}
 */
export const fetchPopularAuthors = (query) => {
	const url = '/api/users/experts/all'
	return axios.get(url, { params: query })
}

/**
 * @param {Number} id User ID
 * @returns {Promise<Object>}
 */
export const getAuthor = (id) => {
	const url = `/api/users/experts/${id}`
	return axios.get(url)
}

/**
 * @param {Number} id User ID
 * @returns {Promise<Object>}
 */
export const getSpeaker = (id) => {
	const url = `/api/speakers/${id}?expand=speakerView&fields=speakerView`
	return axios.get(url)
}

/**
 * @param {Number} id session id
 * @param {String} type session type
 * @returns {Promise<Object>}
 */
export const getSpeakerSessions = (id, type = '', page = 1) => {
	const url = `/api/speaker-sessions?speaker_id=${id}&page=${page}&filter=${type}&expand=event`
	return axios.get(url)
}

/**
 * @param {Number} userId User ID
 * @returns {Promise<Object>}
 */
export const getFollowers = (userId) => {
	const url = `api/users/${userId}/followers`
	return axios.get(url)
}

/**
 * @param {Number} userId User ID
 * @returns {Promise<Object>}
 */
export const getFollowings = (userId) => {
	const url = `/api/users/${userId}/followings`
	return axios.get(url)
}

/**
 * @param {Number} userId User ID
 * @returns {Promise<Object>}
 */
export const followUser = (userId) => {
	const url = `/api/users/${userId}/follow`
	return axios.post(url)
}

/**
 * @param {Number} userId User ID
 * @returns {Promise<Object>}
 */
export const unfollowUser = (userId) => {
	const url = `/api/users/${userId}/unfollow`
	return axios.post(url)
}
